$(function(){
    $("#article_section .toc_button").on("click", function() {
        $(this).toggleClass("on-click");
        $("#article_section .toc_more").slideToggle(1000);

        let buttonText = $(this).text() === "開く" ? "隠す" : "開く";
        $(this).text(buttonText);
    });
  });

$(function() {
  $(".itemBlock").each(function() {
    const $block = $(this);
    const $specsMore = $block.find(".specsMore");
    const $dlItems = $specsMore.find("dl");
    const $button = $block.find(".specsMore_button");
    let isExpanded = false; // 開閉状態を管理
    let lastWindowWidth = window.innerWidth; // 前回のウィンドウ幅を記録

    function updateVisibleItems() {
        const windowWidth = window.innerWidth;
        const visibleCount = windowWidth <= 768 ? 2 : 4;

        // ボタンの表示・非表示を制御
        if ($dlItems.length > visibleCount) {
            $button.show();
        } else {
            $button.hide();
        }

        if (!isExpanded) {
            if (windowWidth > 768 && lastWindowWidth <= 768) {
                // **768px → 769px に切り替わったとき**
                $dlItems.show(); // **すべて表示してから**
                $dlItems.slice(visibleCount).hide(); // **3つ目以降を非表示**
                $button.hide(); // **ボタンも非表示に戻す**
            } else {
                // **通常のリサイズ処理**
                $dlItems.each(function(index) {
                    if (index < visibleCount) {
                        $(this).stop(true, true).slideDown(300);
                    } else {
                        $(this).stop(true, true).slideUp(300);
                    }
                });
            }
        }

        lastWindowWidth = windowWidth; // **現在のウィンドウ幅を記録**
    }

    // 初期実行
    updateVisibleItems();

    // リサイズ時にも実行（debounce付き）
    let resizeTimer;
    $(window).on("resize", function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(updateVisibleItems, 200);
    });

    // ボタンクリックでトグル
    $button.on("click", function() {
        if (isExpanded) {
            isExpanded = false;
            $(this).removeClass("expanded").text("全部を見る");
            updateVisibleItems();
        } else {
            isExpanded = true;
            $dlItems.slideDown();
            $(this).addClass("expanded").text("閉じる");
        }
    });
});
});




/**
 * 指定したセレクターの .splide をすべて初期化する共通関数
 * @param {string} selector - 初期化対象の親要素のセレクター
 * @param {object} options - Splide の設定オプション
 */
function initSplides(selector, options) {
  document.querySelectorAll(`${selector} .splide`).forEach(splideEl => {
    new Splide(splideEl, options).mount();
  });
}

// itemBlock--small 用
initSplides('#article_section .itemBlock--small', {
  type   : 'loop',
  perPage: 5,
  perMove: 1,
  gap    : 15,
  focus  : 0,
  arrows : false,
  pagination: true,
  breakpoints: {
    914: {
      perPage: 3,
      arrows : true
    },
    768: {
      perPage: 2,
      arrows : true
    },
  }
});

// itemBlock--large 用
initSplides('#article_section .itemBlock--large', {
  type   : 'loop',
  perPage: 1,
  perMove: 1,
  focus  : 0,
  pagination: true,
  breakpoints: {
    768: {
      arrows: true
    },
  }
});

// related 用
initSplides('#article_section .related', {
  type   : 'loop',
  perPage: 5,
  perMove: 1,
  gap    : 20,
  focus  : 0,
  arrows : false,
  pagination: true,
  breakpoints: {
    768: {
      perPage: 3,
      arrows : false
    },
  }
});



/*$(function () {
  let scrollPosition = 0;

  $('#modal_area .modal-content').hide();
  $('#modal_area').hide();
  $('.modal-overlay').hide();

  $('.modal-opn_btn').on('click', function (e) {
    e.preventDefault();

    var targetId = $(this).data('target');

    $('#modal_area .modal-content').hide();
    $('#' + targetId).show();
    $('#modal_area').fadeIn();
    $('.modal-overlay').show().css('display', 'block');

    // iOS対応: スクロール位置を固定（戻せるように保存）
    scrollPosition = $(window).scrollTop();
    $('body').addClass('modal-open').css({
      top: -scrollPosition + 'px'
    });
  });

  $('.modal-cls_btn').on('click', function () {
    $('#modal_area').fadeOut(function() {
      $('#modal_area .modal-content').hide();
    });
    $('.modal-overlay').hide().removeAttr('style');

    // スクロールを戻す（iOS対策含む）
    $('body').removeClass('modal-open').removeAttr('style');
    $(window).scrollTop(scrollPosition);
  });
});*/


$(function() {
	$('.modal-open').click(function() {
		clientWidth = $('body').width();
		$('body').css({ 'overflow':'hidden' });
		clientWidthNoScrollBar = $('body').width();
		diff = clientWidthNoScrollBar - clientWidth;
		if (diff > 0) {
			$('body').css({ 'padding-right':diff });
		}
		$('#modal_wrap').append('<div class="modal-overlay"></div>');
		$('.modal-overlay').fadeIn();
		var modal = '#' + $(this).attr('data-target');
		modalResize();
		$(modal).fadeIn();

		$('.modal-overlay, .modal-close').off().click(function() {
			$('body').css({ 'overflow':'auto' });
			$('body').css({ 'padding-right':'0' });
			$(modal).hide();
			$('.modal-overlay').fadeOut('fast', function() {
				$('.modal-overlay').remove();
			});
		});

		$(window).on('resize', function() {
			modalResize();
		});

		function modalResize() {
			var w = $(window).width();
			var h = $(window).height();
			var x = (w - $(modal).outerWidth(true)) / 2;
			var y = (h - $(modal).outerHeight(true)) / 2;
			$(modal).css({'left': x + 'px','top': y + 'px'});
		}
	});
});